import {
  Component,
  ElementRef,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { ModerationStatusEnum } from '@admin/announcements/shared/enums/announcement-enums';
import { JobseekerService } from '../shared/services/jobseeker.service';
import { GenericResult } from '@admin/shared/models/generic-result';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { CustomMessageService } from '@admin/core/message.service';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { MessageType } from '@admin/core/models/enum/message-type';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-jobseeker-list-details',
  templateUrl: './jobseeker-list-details.component.html',
  styleUrls: ['./jobseeker-list-details.component.less'],
  standalone: false,
})
export class JobseekerListDetailsComponent {
  @Input() public jobseekerDetails: any;
  @Input() public jobseekerProfile!: string;
  @ViewChild('activationLink') activationLink!: ElementRef;
  @Output() refreshPageEvent = new EventEmitter();
  public statusEnum: any;
  public resetPassword: string;

  public onResetPasswordClick() {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }
    let jobseekerId = this.jobseekerDetails.jobseekerId;
    this.jobseekerService
      .getTemporaryPassword(jobseekerId)
      .subscribe((result) => {
        this.resetPassword = result.resetPassword;
      });
  }

  onJobseekerDelete(jobseekerId: number) {
    if (!confirm(this.translateService.instant('message.AreYouSure'))) {
      return;
    }

    this.jobseekerService.deleteJobseeker(jobseekerId).subscribe((d) => {
      this.jobseekerDeleteResult(d);
    });
  }

  jobseekerDeleteResult(result: any) {
    if (result.success) {
      this.refreshPageEvent.emit();
    } else {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Error,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translateService.instant('message.' + result.error),
      });
    }
  }

  copyText(overlayPanel, event, activationLink) {
    overlayPanel.toggle(event);
    if (activationLink && navigator.clipboard) {
      navigator.clipboard
        .writeText(activationLink)
        .then(() => console.log('Text copied successfully!'))
        .catch((err) => console.error('Clipboard write failed:', err));
    } else {
      return this.copyWithExecCommand(activationLink);
    }
  }

  private copyWithExecCommand(text: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed'; // Prevent scrolling to bottom
      document.body.appendChild(textarea);
      textarea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          resolve();
        } else {
          reject(new Error('Copy failed'));
        }
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  public clearPassword(event: any) {
    this.resetPassword = null;
  }

  public getLogColor(status) {
    if (status === this.statusEnum.Approved) {
      return LogColors.Approved;
    } else if (status === this.statusEnum.Rejected) {
      return LogColors.Rejected;
    } else if (status === this.statusEnum.Pending) {
      return LogColors.Pending;
    } else if (status === this.statusEnum.Overriden) {
      return LogColors.Overriden;
    }
  }

  constructor(
    private jobseekerService: JobseekerService,
    private translateService: TranslateService,
    private messageService: CustomMessageService
  ) {
    this.statusEnum = ModerationStatusEnum;
  }

  ngOnInit() {}
}
export enum LogColors {
  Approved = '#85C226',
  Rejected = '#F00',
  Pending = '#F7CD3A',
  Overriden = '#FF6500',
}
